<template>
    <iframe id="support-iframe" :src="supportUrl" frameborder="0"></iframe>
</template>

<style lang="scss">
@import "@/assets/scss/pages/support.scss";
</style>

<script>
import { computed } from "@vue/composition-api";
import useAppConfig from "@/composables/useAppConfig";

export default {
    setup() {
        const { language } = useAppConfig();

        const supportUrl = computed(() => {
            if (language.value === "en") {
                return "https://help.saysimple.com/";
            }

            return `https://help.saysimple.com/${language.value}`;
        });

        return {
            supportUrl,
        };
    },
};
</script>
